function subscribeToCalendars(aSubscribeUrl, aCalendars)
{
    if (typeof aSubscribeUrl === 'undefined') return;
    var lCalendars = (typeof aCalendars === 'undefined') ? '' : aCalendars;
    var lLoadingHTML = '<div class="fbcms_calendar_grid_loading">'
        + '<img src="/img/spacer.gif" alt="Loading Subscriptions..." title="Loading Subscriptions..."/>'
        + '<div>Loading Subscriptions...</div>'
        + '</div>';

    var lErrorHTML ='<div class="fbcms_calendar_grid_error">'
        + '<img src="/img/spacer.gif" alt="Error Loading Subscriptions." title="Error Loading Subscriptions."/>'
        + '<div>Error Loading Subscriptions.</div>'
        + '</div>';

    $('#subscribe_calendar_dialog').remove();
    $('body').append('<div id="subscribe_calendar_dialog" title="Subscribe to Calendars"></div>');
    $('#subscribe_calendar_dialog').html(lLoadingHTML).dialog(
    {
        title: "Subscribe to Calendars",
        width: 600,
        height: 400,
        modal: true,
        close: function (event, ui)
        {
            $(this).dialog('destroy').remove();
        },
        open: function (event, ui)
        {
            FBUtilities.UpdateWidgetOverlayStyle(this);

            $('#subscribe_calendar_dialog').on("click", ".feed_button", function (e)
            {
                e.preventDefault();
                try
                {
                    var textFieldId = $(this).data("for");
                    var copyText = document.querySelector(`#${textFieldId}`);
                    copyText.select();
                    document.execCommand("copy");
                }
                catch (error)
                {
                    console.error(error);
                }
                return false;
            });

            $.ajax(aSubscribeUrl, {
                success: function (data, textStatus, jqXHR)
                {
                    $('#subscribe_calendar_dialog').html(data);
                },
                error: function (jqXHR, textStatus, errorThrown)
                {
                    $('#subscribe_calendar_dialog').html(lErrorHTML);
                },
                data:
                {
                    Calendars: lCalendars,
                    rndm: Math.random()
                },
                type: 'GET'
            });
        }
    });
}
